import React, { useMemo } from 'react';
import { useInternationalization } from '@progress/kendo-react-intl';
import { useSearchContext } from '../../../context/search/SearchContext';
import { useGlobalizationContext } from '../../../context/globalization/GlobalizationContext';
import { useTranslation } from '../../../context/globalization/useTranslation';

const SearchResultsCount: React.FC = () => {
  const { selectedLocale } = useGlobalizationContext();
  const { translate } = useTranslation(selectedLocale);
  const intl = useInternationalization();
  const { data } = useSearchContext();

  const resultsCount = useMemo(() => {
    if (!data) {
      return 0;
    }
    return data.totalCount;
  }, [data]);

  return (
    <div className="searchResultsCount">
      {intl.formatNumber(resultsCount, '0')} {translate('custom.toolbar.searchResults')}
    </div>
  );
};

export default SearchResultsCount;
